/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { MyContext } from "../Context/MyProvider";
import BookingDetails from "./DocAppointment/BookingDetails";
import AddPatient from "./DocAppointment/AddPatient";
import { FaStar } from "react-icons/fa";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import OneSignal from "react-onesignal";
import { useTranslation } from "react-i18next";
import LocationImg from "../assets/Image/permission.png";
import { showToast } from "../showTost";
import Loading from "./Loading";
import NotificationImg from "../assets/Image/Notification.png";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "./ImageLoad";
import Banner from "./Banner";
import { motion } from "framer-motion";

const CustomPrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-8 h-8 rounded-full bg-white/95 backdrop-blur-sm border border-slate-200/80 flex items-center justify-center absolute z-10 right-[44px] -top-[42px] transform -translate-y-1/2 hover:bg-indigo-600 hover:border-indigo-600 hover:text-white text-slate-700 shadow-sm hover:shadow active:scale-95 transition-all duration-200"
    aria-label="Previous slide"
  >
    <MdChevronLeft className="w-5 h-5" />
  </button>
);

const CustomNextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="w-8 h-8 rounded-full bg-white/95 backdrop-blur-sm border border-slate-200/80 flex items-center justify-center absolute z-10 right-0 -top-[42px] transform -translate-y-1/2 hover:bg-indigo-600 hover:border-indigo-600 hover:text-white text-slate-700 shadow-sm hover:shadow active:scale-95 transition-all duration-200"
    aria-label="Next slide"
  >
    <MdChevronRight className="w-5 h-5" />
  </button>
);

const Dashboard = () => {

  const { t } = useTranslation();

  const {
    ApiBaseUrl,
    ImgBaseUrl,
    patientStatus,
    isLogin,
    setAgoraAppId,
    setVideoCallProvider,
    setVideoCallConfig,
    setMapKey,
    setIsLoginShow,
    paymentStatus,
    setPaymentStatus,
  } = useContext(MyContext);

  const [loading, setLoading] = useState(true);
  const [sliderImg, setSliderImg] = useState([]);
  const [bookingData, setBookingData] = useState();
  const [isBooking, setIsBooking] = useState(false);
  const [familyMemberList, setFamilyMemberList] = useState([]);
  const [isPatient, setIsPatient] = useState(false);
  const [relationshipData, setRelationshipData] = useState([]);
  const [booldData, setBooldData] = useState([]);
  const [patientData, setPatientData] = useState();
  const [favoritList, setFavoriteList] = useState([]);
  const [dynamicList, setDynamicList] = useState([]);
  const [deviceCheck, setDeviceCheck] = useState(false);
  const [locationError, setLocationError] = useState(false);
  const [notificationerror, setNotificationError] = useState(false);

  const CategoryList = [
    {
      label: t("Talk to Doctor"),
      href: "/video-consultation-doctors",
      active: false,
      gradient: "from-[#00BCD4] to-[#00E5FF]",
      color: "text-[#00BCD4]",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-7 h-7 transition-all group-hover:scale-110"
          aria-hidden="true"
        >
          <path d="M11 2v2"></path>
          <path d="M5 2v2"></path>
          <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"></path>
          <path d="M8 15a6 6 0 0 0 12 0v-3"></path>
          <circle cx="20" cy="10" r="2"></circle>
        </svg>
      ),
    },
    {
      label: t("Appointment Book"),
      href: "/services",
      active: false,
      gradient: "from-blue-400 to-indigo-500",
      color: "text-blue-600",
      icon: (
        <svg
          className="w-7 h-7 transition-all group-hover:scale-110"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM9.02002 13C9.02002 13.552 8.57302 14 8.02002 14C7.46802 14 7.01489 13.552 7.01489 13C7.01489 12.448 7.45801 12 8.01001 12H8.02002C8.57202 12 9.02002 12.448 9.02002 13ZM13.02 13C13.02 13.552 12.573 14 12.02 14C11.468 14 11.0149 13.552 11.0149 13C11.0149 12.448 11.458 12 12.01 12H12.02C12.572 12 13.02 12.448 13.02 13ZM17.02 13C17.02 13.552 16.573 14 16.02 14C15.468 14 15.0149 13.552 15.0149 13C15.0149 12.448 15.458 12 16.01 12H16.02C16.572 12 17.02 12.448 17.02 13ZM9.02002 17C9.02002 17.552 8.57302 18 8.02002 18C7.46802 18 7.01489 17.552 7.01489 17C7.01489 16.448 7.45801 16 8.01001 16H8.02002C8.57202 16 9.02002 16.448 9.02002 17ZM13.02 17C13.02 17.552 12.573 18 12.02 18C11.468 18 11.0149 17.552 11.0149 17C11.0149 16.448 11.458 16 12.01 16H12.02C12.572 16 13.02 16.448 13.02 17ZM17.02 17C17.02 17.552 16.573 18 16.02 18C15.468 18 15.0149 17.552 15.0149 17C15.0149 16.448 15.458 16 16.01 16H16.02C16.572 16 17.02 16.448 17.02 17Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      label: t("Book Clinic Visit"),
      href: "/clinic-visit-doctors",
      active: false,
      gradient: "from-purple-400 to-pink-500",
      color: "text-purple-600",
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="w-7 h-7 transition-all group-hover:scale-110"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 3.75H16.75V3C16.75 2.586 16.414 2.25 16 2.25C15.586 2.25 15.25 2.586 15.25 3V3.75H8.75V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V3.75H6C3.582 3.75 2.25 5.082 2.25 7.5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V7.5C21.75 5.082 20.418 3.75 18 3.75ZM6 5.25H7.25V6C7.25 6.414 7.586 6.75 8 6.75C8.414 6.75 8.75 6.414 8.75 6V5.25H15.25V6C15.25 6.414 15.586 6.75 16 6.75C16.414 6.75 16.75 6.414 16.75 6V5.25H18C19.577 5.25 20.25 5.923 20.25 7.5V8.25H3.75V7.5C3.75 5.923 4.423 5.25 6 5.25ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V9.75H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM15.25 15C15.25 15.414 14.914 15.75 14.5 15.75H12.75V17.5C12.75 17.914 12.414 18.25 12 18.25C11.586 18.25 11.25 17.914 11.25 17.5V15.75H9.5C9.086 15.75 8.75 15.414 8.75 15C8.75 14.586 9.086 14.25 9.5 14.25H11.25V12.5C11.25 12.086 11.586 11.75 12 11.75C12.414 11.75 12.75 12.086 12.75 12.5V14.25H14.5C14.914 14.25 15.25 14.586 15.25 15Z"
            fill="currentColor"
          />
        </svg>
      ),
    },
    {
      label: t("Medicine"),
      href: "/shop",
      active: false,
      gradient: "from-emerald-400 to-teal-500",
      color: "text-emerald-600",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-7 h-7 transition-all group-hover:scale-110"
          aria-hidden="true"
        >
          <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
          <path d="m8.5 8.5 7 7"></path>
        </svg>
      ),
    },
    {
      label: t("Lab Test & Packages"),
      href: "/lab-details",
      active: false,
      gradient: "from-orange-400 to-red-500",
      color: "text-orange-600",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-7 h-7 transition-all group-hover:scale-110"
          aria-hidden="true"
        >
          <path d="M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3"></path>
          <path d="m16 2 6 6"></path>
          <path d="M12 16H4"></path>
        </svg>
      ),
    },
  ];

  const navigate = useNavigate();
  const initialized = useRef(false);
  const HomeRef = useRef(false);

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const Patientsetting = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 7,
    slidesToScroll: 1,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    initialSlide: 0,
    responsive: [
      { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
      { breakpoint: 770, settings: { slidesToShow: 5, slidesToScroll: 1 } },
      { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 430, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 380, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    ],
  };

  const boxsetting = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 430, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const labsetting = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      { breakpoint: 770, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = String(position.coords.latitude);
          const long = String(position.coords.longitude);
          fetchHomeData(lat, long);
          HandleGetmember();
          handleNotificationModel();
        },
        (error) => {
          if (!secureLocalStorage.getItem("location")) {
            setLocationError(true);
          } else {
            handleNotificationModel();
            fetchHomeData(21.215814, 72.828308);
          }
        },
      );
    }
  }, [isLogin]);

  const handleNotificationModel = () => {
    if ("Notification" in window) {
      Notification.requestPermission().then((res) => {
        if (res === "denied") {
          if (!secureLocalStorage.getItem("notification")) {
            setNotificationError(true);
          }
        }
      });
    }
  };

  const fetchHomeData = (lat, lon) => {
    if (HomeRef.current) return;
    HomeRef.current = true;
    setLoading(true);
    const Userid = secureLocalStorage.getItem("Userid") || "0";
    axios
      .post(`${ApiBaseUrl}/customer/home`, { id: String(Userid), lat, lon })
      .then((res) => {
        const {
          banner_data,
          general_currency,
          ResponseCode,
          fav_doctor_list,
          dynamic_list,
          wallet,
        } = res.data;
        if (ResponseCode === 200) {
          setSliderImg(banner_data);
          setFavoriteList(fav_doctor_list);
          setDynamicList(dynamic_list);
          secureLocalStorage.setItem(
            "currency",
            general_currency.site_currency,
          );
          OneSignalHandle(general_currency.one_app_id_react);
          setAgoraAppId(general_currency.agora_app_id);
          secureLocalStorage.setItem(
            "agora_app_id",
            general_currency.agora_app_id,
          );
          if (general_currency.video_call_provider) {
            setVideoCallProvider(general_currency.video_call_provider);
            secureLocalStorage.setItem(
              "video_call_provider",
              general_currency.video_call_provider,
            );
          }
          if (general_currency.video_call_config) {
            setVideoCallConfig(general_currency.video_call_config);
            secureLocalStorage.setItem(
              "video_call_config",
              JSON.stringify(general_currency.video_call_config),
            );
          }
          setMapKey(general_currency.google_map_key);
          secureLocalStorage.setItem("wallet", wallet);
        }
        setLoading(false);
      })
      .catch((error) => {
        // console.error("Home Api", error);
      });
  };

  useEffect(() => {
    if (patientStatus) {
      HandleGetmember();
      setIsPatient(false);
    }
  }, [patientStatus]);

  const HandleGetmember = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/family_member_list`, { id: Userid })
        .then((res) => {
          setFamilyMemberList(res.data.family_member);
        })
        .catch((error) => {
          console.error(error);
        });
        
      axios
        .get(`${ApiBaseUrl}/customer/family_member_add_detail`)
        .then((res) => {
          const { relationship_list, blood_group_list } = res.data;
          setRelationshipData(relationship_list);
          setBooldData(blood_group_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const status = sessionStorage.getItem("Bookid");
    if (status) {
      HandleBookAppointGet(status);
    }
  }, []);

  const HandleBookAppointGet = (id) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/success_appo_detail`, {
          id: Userid,
          appointment_id: id,
        })
        .then((res) => {
          // console.log("success_appo_detail", res);
          setIsBooking(true);
          setBookingData(res.data);
          sessionStorage.removeItem("Bookid");
        })
        .catch((error) => {
          console.error("success_appo_detail", error);
        });
    }
  };

  const HandleGetPatientDetails = (id) => {
    axios
      .post(`${ApiBaseUrl}/customer/family_member_detail`, { fid: id })
      .then((res) => {
        // console.log(res);
        setPatientData(res.data.data);
        setIsPatient(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const HandleNavigateDoc = (title, Id, departmentid) => {
    navigate(`/doctor-profile/${departmentid}/${Id}`);
    sessionStorage.setItem(
      "Docprofile",
      JSON.stringify({ title, path: "/", pagename: "Home" }),
    );
  };

  const HandleNavigateLab = (item, category, type) => {
    if (type === "Lab") {
      navigate("/packages");
      sessionStorage.setItem(
        "Docprofile",
        JSON.stringify({
          Categoryid: category,
          Labid: item.id,
          title: "Home",
          path: "/",
        }),
      );
    } else {
      navigate("/store-home");
      sessionStorage.setItem(
        "Docdetails",
        JSON.stringify({ Docid: item.id, Categoreyid: item.department_id }),
      );
    }
  };

  const OneSignalHandle = (AppId) => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (Userid && !initialized.current) {
      OneSignal.init({
        appId: AppId,
        safari_web_id: "web.onesignal.auto.xxx",
        notifyButton: {
          enable: true,
        },
        serviceWorkerParam: { scope: "/" },
        serviceWorkerPath: "OneSignalSDKWorker.js",
        allowLocalhostAsSecureOrigin: true,
      })
        .then(() => {
          initialized.current = true;
          OneSignal.User.addTags({
            user_id: Userid,
          });
        })
        .catch((error) => {
          // console.error("OneSignal :-->>", error);
        });
    }
  };

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  const HandleAddPatient = () => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      setIsPatient(true);
      setPatientData("");
    } else {
      setIsLoginShow(true);
    }
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentFaild") {
      showToast({ title: "Payment Closed !!", id: "info" });
      setPaymentStatus("");
    }
  }, [paymentStatus]);

  const HandleLocationEnable = () => {
    setLocationError(false);
    secureLocalStorage.setItem("location", true);
    HomeRef.current = false;
    fetchHomeData(21.215814, 72.828308);
  };

  const HandleNotificationEnable = () => {
    setNotificationError(false);
    secureLocalStorage.setItem("notification", true);
  };

  const handleNavigateCat = (path) => {
    navigate(path);
  };

  return (
    <div className="dashboard pb-10 bg-slate-50/30">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
      ) : (
        <div>
          <div className="width-container px-4 md:px-6">
            <div className="flex items-center justify-start md:justify-center gap-4 md:gap-6 overflow-x-auto py-8 mb-4 scrollbar-none">
              {CategoryList.map((item, index) => {
                const isActive = item.active;
                return (
                  <motion.div
                    key={index}
                    onClick={() => handleNavigateCat(item.href, item.label)}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.05 }}
                    whileHover={{ scale: 1.05, y: -4 }}
                    className="flex flex-col items-center gap-2.5 min-w-[110px] group cursor-pointer"
                  >
                    <div className="relative">
                      <div
                        className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-20 blur-xl transition-all duration-300 rounded-full`}
                      />
                      <div
                        className={`relative w-16 h-16 rounded-full p-[2px] bg-gradient-to-br ${item.gradient} shadow-sm group-hover:shadow-md transition-all duration-300`}
                      >
                        <div className="w-full h-full bg-white rounded-full flex items-center justify-center shadow-inner">
                          <div
                            className={`w-7 h-7 transition-all duration-300 ${item.color} group-hover:scale-110 flex items-center justify-center`}
                          >
                            {item.icon}
                          </div>
                        </div>
                      </div>
                    </div>
                    <span
                      className={`text-xs text-center font-semibold tracking-wide transition-colors duration-200 ${
                        isActive
                          ? item.color
                          : `text-slate-600 group-hover:text-indigo-650`
                      }`}
                    >
                      {item.label}
                    </span>
                    {isActive && (
                      <motion.div
                        className={`h-1 w-8 bg-gradient-to-r ${item.gradient} rounded-full mt-0.5`}
                        animate={{ width: ["24px", "32px", "24px"] }}
                        transition={{
                          duration: 1.5,
                          repeat: Infinity,
                          ease: "easeInOut",
                        }}
                      />
                    )}
                  </motion.div>
                );
              })}
            </div>

            {/* Banner Component */}
            <div className="mb-8 rounded-3xl overflow-hidden shadow-sm border border-slate-100/60 bg-white p-1">
              <Banner images={sliderImg} />
            </div>

            {/* My Patients Section */}
            <div className="bg-white border border-slate-100 rounded-3xl p-6 mb-8 shadow-sm">
              <h2 className="text-xl font-bold text-slate-800 tracking-tight mb-1">
                {t("My Patient")}
              </h2>
              <p className="text-xs text-slate-400 mb-5">
                {t("Select or add patients for booking appointments")}
              </p>
              <div className="slider-container relative">
                <Slider {...Patientsetting}>
                  <div className="px-2">
                    <div
                      onClick={HandleAddPatient}
                      className="h-[170px] border-2 border-dashed border-indigo-200/80 bg-indigo-50/20 text-center rounded-2xl cursor-pointer hover:bg-indigo-50/50 hover:border-indigo-400/80 transition-all duration-300 my-2 flex flex-col justify-center items-center p-4 gap-3 group shadow-sm"
                    >
                      <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-sm text-indigo-600 group-hover:scale-105 transition-all">
                        <FiPlus className="text-xl" />
                      </div>
                      <h3 className="text-indigo-600 font-bold text-sm tracking-wide">
                        {t("Add New Patient")}
                      </h3>
                    </div>
                  </div>
                  {familyMemberList.map((item, index) => {
                    return (
                      <div key={index} className="px-2">
                        <div
                          onClick={() => HandleGetPatientDetails(item.id)}
                          className="h-[170px] bg-white border border-slate-100/80 text-center rounded-2xl cursor-pointer hover:shadow-md hover:-translate-y-1 hover:border-indigo-100 transition-all duration-300 my-2 flex flex-col justify-center items-center p-4 shadow-sm"
                        >
                          <div className="w-[70px] h-[70px] bg-slate-50 flex items-center justify-center rounded-full overflow-hidden border border-slate-100 shadow-inner">
                            <ImageLoad
                              src={ImgBaseUrl + item.profile_image}
                              CustomeStyle="w-full h-full object-cover"
                              alt="profile"
                            />
                          </div>
                          <div className="mt-3">
                            <h4 className="font-bold text-slate-800 text-sm truncate max-w-[120px]">
                              {item.name}
                            </h4>
                            <p className="text-xs text-slate-400 font-medium mt-0.5">
                              {t(item.reletion_name)}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>

            {/* Favorites Section */}
            {favoritList.length >= 1 && (
              <div className="bg-white border border-slate-100 rounded-3xl p-6 mb-8 shadow-sm">
                <div className="mb-5">
                  <h2 className="text-xl font-bold text-slate-800 tracking-tight mb-1">
                    {t("Your favorites")}
                  </h2>
                  <p className="text-xs text-slate-400">
                    {t("Doctor your Love")} 💙
                  </p>
                </div>
                <div className="slider-container relative">
                  <Slider {...Patientsetting}>
                    {favoritList.map((item, index) => {
                      return (
                        <div key={index} className="px-2">
                          <div
                            onClick={() =>
                              HandleNavigateDoc(
                                "Doctor Profile",
                                item.id,
                                item.department_id,
                              )
                            }
                            className="bg-white border border-slate-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:-translate-y-1 hover:border-indigo-100 transition-all duration-300 my-2 flex flex-col items-center text-center shadow-sm"
                          >
                            <div className="w-20 h-20 bg-slate-50 rounded-full overflow-hidden border border-slate-100 shadow-inner">
                              <ImageLoad
                                src={ImgBaseUrl + item.logo}
                                CustomeStyle="w-full h-full object-cover"
                                alt="logo"
                              />
                            </div>
                            <h4 className="text-sm font-bold text-slate-800 mt-3 truncate max-w-[120px]">
                              {item.title}
                            </h4>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            )}

            {/* Dynamic Modules List */}
            <div className="dynamic_list flex flex-col gap-8">
              {dynamicList.map((item, index) => {
                if (item.module === "Hospital") {
                  return (
                    <div
                      key={index}
                      className="bg-white border border-slate-100 rounded-3xl p-6 shadow-sm"
                    >
                      <div className="mb-8 relative flex items-center justify-between">
                        <div>
                          <h2 className="text-xl font-bold text-slate-800 tracking-tight">
                            {item.title}
                          </h2>
                          <div className="h-0.5 w-12 bg-indigo-600 rounded-full mt-1.5" />
                        </div>
                      </div>
                      <div className="slider-container relative">
                        <Slider {...boxsetting}>
                          {item.details.map((subItem, subIndex) => {
                            return (
                              <div key={subIndex} className="px-2">
                                <div
                                  onClick={() =>
                                    HandleNavigateDoc(
                                      subItem.name,
                                      subItem.id,
                                      subItem.department_id,
                                    )
                                  }
                                  className="bg-white border border-slate-100 rounded-2xl overflow-hidden cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all duration-300 my-2 shadow-sm relative group flex flex-col h-full isolate"
                                >
                                  <div className="relative overflow-hidden h-[180px] rounded-t-2xl isolate">
                                    <ImageLoad
                                      src={ImgBaseUrl + subItem.logo}
                                      CustomeStyle="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 transform-gpu"
                                      alt="hospital logo"
                                    />
                                    <div className="absolute top-3 left-3 bg-slate-900/60 backdrop-blur-md px-2.5 py-1 rounded-full text-white font-bold text-xs flex items-center gap-1 border border-white/10 shadow-sm">
                                      <FaStar className="text-amber-400 text-sm" />
                                      <span>{subItem.avg_star}</span>
                                    </div>
                                  </div>
                                  <div className="p-4 flex flex-col justify-between flex-1 gap-2.5">
                                    <div>
                                      <h3 className="font-bold text-slate-800 text-base leading-snug group-hover:text-indigo-650 transition-colors truncate">
                                        {subItem.name}
                                      </h3>
                                      <div className="flex items-center gap-1 text-slate-400 text-xs mt-1.5">
                                        <svg
                                          width="14"
                                          height="14"
                                          className="shrink-0"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                        <p className="truncate leading-none">
                                          {subItem.address}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="pt-3 border-t border-slate-50 flex items-center justify-between mt-1">
                                      <span className="text-xs text-slate-400 font-medium">
                                        {t("Consultation Fees")}
                                      </span>
                                      <span className="font-extrabold text-indigo-600 text-base">
                                        {currency}
                                        {subItem.client_visit_price}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    </div>
                  );
                } else if (item.module === "Lab" || item.module === "Store") {
                  return (
                    <div
                      key={index}
                      className="bg-white border border-slate-100 rounded-3xl p-6 shadow-sm"
                    >
                      <div className="mb-8 relative flex items-center justify-between">
                        <div>
                          <h2 className="text-xl font-bold text-slate-800 tracking-tight">
                            {item.title}
                          </h2>
                          <div className="h-0.5 w-12 bg-indigo-600 rounded-full mt-1.5" />
                        </div>
                      </div>
                      <div className="slider-container relative">
                        <Slider {...labsetting}>
                          {item.details.map((subItem, subIndex) => {
                            return (
                              <div key={subIndex} className="px-2">
                                <div
                                  onClick={() =>
                                    HandleNavigateLab(
                                      subItem,
                                      item.category,
                                      item.module,
                                    )
                                  }
                                  className="bg-white border border-slate-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 my-2 shadow-sm relative group flex items-center gap-3.5 isolate"
                                >
                                  <div className="w-20 h-20 overflow-hidden rounded-xl border border-slate-100 shrink-0 bg-slate-50 shadow-inner isolate">
                                    <ImageLoad
                                      src={ImgBaseUrl + subItem.logo}
                                      CustomeStyle="w-full h-full object-cover group-hover:scale-102 transition-transform duration-300 transform-gpu"
                                      alt="logo"
                                    />
                                  </div>
                                  <div className="overflow-hidden w-full flex flex-col justify-center">
                                    <h3 className="font-bold text-slate-800 text-base leading-snug group-hover:text-indigo-650 transition-colors truncate">
                                      {subItem.name}
                                    </h3>
                                    <p className="text-xs text-slate-400 truncate mt-1">
                                      {subItem.address}
                                    </p>
                                    <div className="flex items-center gap-2.5 justify-between mt-3">
                                      <div className="flex items-center gap-1 text-slate-700 text-xs font-semibold bg-slate-50 px-2 py-0.5 rounded-lg border border-slate-100/50">
                                        <FaStar className="text-amber-400 text-sm" />
                                        <span>{subItem.avg_star}</span>
                                        <span className="text-slate-400 font-normal">
                                          ({subItem.tot_review})
                                        </span>
                                      </div>
                                      <div className="flex items-center gap-1 text-indigo-650 text-xs font-bold bg-indigo-50/50 px-2 py-0.5 rounded-lg border border-indigo-100/20">
                                        <svg
                                          width="12"
                                          height="12"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                        <span>{subItem.distance} KM</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index}
                      className="bg-white border border-slate-100 rounded-3xl p-6 shadow-sm"
                    >
                      <div className="mb-8 relative flex items-center justify-between">
                        <div>
                          <h2 className="text-xl font-bold text-slate-800 tracking-tight">
                            {item.title}
                          </h2>
                          <div className="h-0.5 w-12 bg-indigo-600 rounded-full mt-1.5" />
                        </div>
                      </div>
                      <div className="slider-container relative">
                        <Slider {...boxsetting}>
                          {item.details.map((subItem, subIndex) => {
                            return (
                              <div key={subIndex} className="px-2">
                                <div
                                  onClick={() =>
                                    HandleNavigateDoc(
                                      subItem.name,
                                      subItem.id,
                                      subItem.department_id,
                                    )
                                  }
                                  className="bg-white border border-slate-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:-translate-y-1 transition-all duration-300 my-2 shadow-sm relative group flex flex-col isolate"
                                >
                                  <div className="relative overflow-hidden h-[180px] rounded-t-2xl isolate">
                                    <ImageLoad
                                      src={ImgBaseUrl + subItem.logo}
                                      CustomeStyle="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 transform-gpu"
                                      alt="logo"
                                    />
                                    <div className="absolute top-3 left-3 bg-slate-900/60 backdrop-blur-md px-2.5 py-1 rounded-full text-white font-bold text-xs flex items-center gap-1 border border-white/10 shadow-sm">
                                      <FaStar className="text-amber-400 text-sm" />
                                      <span>{subItem.avg_star}</span>
                                    </div>
                                  </div>
                                  <div className="pt-4 flex flex-col gap-2">
                                    <div>
                                      <h3 className="font-bold text-slate-800 text-base leading-tight group-hover:text-indigo-650 transition-colors truncate">
                                        {subItem.name}
                                      </h3>
                                      <span className="text-xs text-indigo-650 font-bold bg-indigo-50 self-start px-2 py-0.5 rounded inline-block mt-1">
                                        {subItem.title}
                                      </span>
                                    </div>
                                    <div className="flex items-center gap-1 text-slate-400 text-xs mt-1 border-b border-slate-50 pb-3.5">
                                      <svg
                                        width="14"
                                        height="14"
                                        className="shrink-0"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                      <p className="truncate leading-none">
                                        {subItem.address}
                                      </p>
                                    </div>
                                    <button className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-750 text-white rounded-xl font-bold text-sm tracking-wide shadow-sm hover:shadow active:scale-98 transition-all flex items-center justify-center gap-2 mt-1">
                                      <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01011 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58601 6.5191 2.29801C7.4791 2.10601 8.4281 2.53401 8.9151 3.35501L10.4781 5.995C11.2371 7.277 10.86 8.928 9.61896 9.754L8.4881 10.506C9.5451 12.676 11.3229 14.459 13.4839 15.515L14.2462 14.378C15.0772 13.139 16.7281 12.768 18.0091 13.531L20.6522 15.107C21.4702 15.595 21.8931 16.55 21.7071 17.482C21.4191 18.925 20.5341 20.196 19.2811 20.969C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86412 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.089 9.91608 18.566 15.5721 20.118C16.5681 20.391 17.604 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8831 16.393L17.241 14.817C16.646 14.463 15.878 14.636 15.492 15.211L14.377 16.876C14.177 17.174 13.7911 17.288 13.4651 17.15C10.5021 15.911 8.09113 13.495 6.85113 10.521C6.71313 10.189 6.82899 9.807 7.12799 9.608L8.78912 8.50299C9.36512 8.11999 9.54007 7.353 9.18707 6.758L7.62408 4.11899C7.48708 3.88699 7.23909 3.75 6.97809 3.75Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                      {t("Book Today")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}

      {/* Centered Booking Modal */}
      {isBooking && (
        <div className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-[28px] p-6 shadow-2xl max-w-md w-full relative">
            <BookingDetails Data={bookingData} />
          </div>
        </div>
      )}

      {isPatient && (
        <div
          onClick={() => setIsPatient(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-in fade-in duration-200"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[28px] shadow-2xl max-w-lg w-full max-h-[85vh] scroll-container p-6 relative"
          >
            {/* Close button */}
            <button
              onClick={() => setIsPatient(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-10"
              aria-label="Close modal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <AddPatient
              Relation={relationshipData}
              BooldType={booldData}
              Data={patientData}
            />
          </div>
        </div>
      )}

      {/* Required for calls alerts modal */}
      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-in fade-in duration-200"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 max-w-md w-full shadow-2xl border border-slate-100 flex flex-col items-center text-center gap-4 relative"
          >
            <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center text-amber-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-slate-800 text-lg">
                {t("Device Connection Required")}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed mt-2">
                {t(
                  "Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.",
                )}
              </p>
            </div>
            <button
              onClick={() => setDeviceCheck(false)}
              className="w-full py-3 bg-indigo-650 hover:bg-indigo-700 text-white rounded-xl font-bold text-sm tracking-wide transition-colors mt-2"
            >
              {t("Okay, Understood")}
            </button>
          </div>
        </div>
      )}

      {locationError && (
        <div className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[9999] p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-[28px] shadow-2xl max-w-sm w-full p-6 flex flex-col items-center text-center relative border border-slate-100">
            <h2 className="text-xl font-bold text-slate-800 tracking-tight mb-2">
              {t("Enable Location Services")}
            </h2>
            <img
              src={LocationImg}
              className="w-full h-full object-contain my-3"
              alt="Location Required"
            />

            <div className="my-3 flex flex-col gap-3 text-left">
              <div className="flex gap-3 items-start">
                <span className="w-5 h-5 rounded-full bg-indigo-50 text-indigo-650 flex items-center justify-center font-bold text-xs shrink-0 mt-0.5">
                  1
                </span>
                <p className="text-xs text-slate-500 leading-relaxed font-medium">
                  {t(
                    "To provide accurate services, please enable your location.",
                  )}
                </p>
              </div>
              <div className="flex gap-3 items-start">
                <span className="w-5 h-5 rounded-full bg-indigo-50 text-indigo-650 flex items-center justify-center font-bold text-xs shrink-0 mt-0.5">
                  2
                </span>
                <p className="text-xs text-slate-500 leading-relaxed font-medium">
                  {t(
                    "Allow location access when prompted. If not prompted, enable it in your browser settings.",
                  )}
                </p>
              </div>
              <p className="text-xs text-amber-600 font-semibold text-center mt-1">
                🔄 {t("Refresh the page after enabling.")}
              </p>
            </div>

            <button
              onClick={HandleLocationEnable}
              className="bg-[--button-color] text-white w-full rounded-xl py-3 mt-4 font-bold text-sm tracking-wide shadow-sm hover:shadow active:scale-[0.98] transition-all"
            >
              {t("Enable Now")}
            </button>
            <button
              onClick={HandleLocationEnable}
              className="border border-slate-200 hover:bg-slate-50 text-slate-600 w-full rounded-xl py-3 mt-2 font-bold text-sm tracking-wide transition-all"
            >
              {t("Default")}
            </button>
          </div>
        </div>
      )}

      {/* Smart Alerts notification modal */}
      {notificationerror && (
        <div className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-[28px] shadow-2xl max-w-sm w-full p-6 flex flex-col items-center text-center relative border border-slate-100">
            <h2 className="text-xl font-bold text-slate-800 tracking-tight mb-2">
              {t("Enable Smart Alerts")}
            </h2>
            <img
              src={NotificationImg}
              className="w-full h-full object-contain my-3 rounded-2xl shadow-sm border border-slate-100"
              alt="Notification Alerts"
            />
            <div className="my-3 flex flex-col gap-3 text-left">
              <div className="flex gap-3 items-start">
                <span className="w-5 h-5 rounded-full bg-indigo-50 text-indigo-650 flex items-center justify-center font-bold text-xs shrink-0 mt-0.5">
                  1
                </span>
                <p className="text-xs text-slate-500 leading-relaxed font-medium">
                  {t(
                    "Let us notify you about upcoming bookings, changes, and key updates directly through your browser.",
                  )}
                </p>
              </div>
              <p className="text-xs text-amber-600 font-semibold text-center mt-1">
                🔄 {t("Refresh the page after enabling.")}
              </p>
            </div>

            <button
              onClick={HandleNotificationEnable}
              className="bg-[--button-color] text-white w-full rounded-xl py-3 mt-4 font-bold text-sm tracking-wide shadow-sm hover:shadow active:scale-[0.98] transition-all"
            >
              {t("Enable Now")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
/* jshint ignore:end */
